import { SupplierMap } from '../../store/SupplierMap';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const createSupplierMapData = (supplierMapData: SupplierMap) => {
  return apiService.callExternalApi<SupplierMap>({
    url: `${API_SERVER_URL}/supplier-maps`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: supplierMapData
  });
};

export const updateSupplierMapData = (supplierMapData: SupplierMap) => {
  return apiService.callExternalApi<SupplierMap>({
    url: `${API_SERVER_URL}/supplier-maps/${supplierMapData.id}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: supplierMapData
  });
};

export const deleteSupplierMapData = (id: string) => {
  return apiService.callExternalApi<SupplierMap>({
    url: `${API_SERVER_URL}/supplier-maps/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listSupplierMaps = () => {
  return apiService.callExternalApi<SupplierMap[]>({
    url: `${API_SERVER_URL}/supplier-maps`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listSupplierMapsByRpmAcctSupplierId = (id: string) => {
  return apiService.callExternalApi<SupplierMap[]>({
    url: `${API_SERVER_URL}/supplier-maps/rpm-supplier/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listSupplierMapsBySFDCSupplierId = (id: string) => {
  return apiService.callExternalApi<SupplierMap[]>({
    url: `${API_SERVER_URL}/supplier-maps/sfdc-supplier/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
